export const translations = {
    en: {
        earnHeading: 'Earn',
        earnAutotrading: 'Autotrading',
        earnToken: 'RCC Token',
        earnReferral: 'Referral',
        earnStaking: 'Staking',
        earnPartner: 'Partner',
        signOut: 'Sign out',
        menu: 'Menu',
        autotrading: 'Exchanges',
        globalMarkets: 'Global markets',
        cryptoMarkets: 'Crypto markets',
        premium: 'Premium',
        guides: 'Guides',
        whitepaper: 'Whitepaper',
        terms: 'Terms & Conditions',
        home: 'Home',
        sitemapPlatform: 'Platform',
        sitemapMarkets: 'Markets',
        sitemapTrading: 'Trading',
        sitemapGuides: 'Guides',
        sitemapLegal: 'Legal',
        disclaimerTitle: 'Risk warning',
        disclaimer:
            'Trading futures, options and crypto derivatives carries a high level of risk and is not suitable for every investor. You may lose some or all of the money you invest. Past performance does not guarantee future results. RealColibri provides trading automation software and does not give investment advice: you make every trading decision yourself and bear responsibility for its outcome. Only trade with money you can afford to lose.',
    },
    es: {
        earnHeading: 'Gana',
        earnAutotrading: 'Autotrading',
        earnToken: 'Token RCC',
        earnReferral: 'Referidos',
        earnStaking: 'Staking',
        earnPartner: 'Socio',
        signOut: 'Cerrar sesión',
        menu: 'Menú',
        autotrading: 'Exchanges',
        globalMarkets: 'Mercados globales',
        cryptoMarkets: 'Mercados de criptomonedas',
        premium: 'Premium',
        guides: 'Guías',
        whitepaper: 'Whitepaper',
        terms: 'Términos y Condiciones',
        home: 'Inicio',
        sitemapPlatform: 'Plataforma',
        sitemapMarkets: 'Mercados',
        sitemapTrading: 'Trading',
        sitemapGuides: 'Guías',
        sitemapLegal: 'Legal',
        disclaimerTitle: 'Advertencia de riesgo',
        disclaimer:
            'Operar con futuros, opciones y derivados de criptomonedas conlleva un alto nivel de riesgo y no es adecuado para todos los inversores. Puede perder una parte o la totalidad del dinero invertido. Los resultados pasados no garantizan resultados futuros. RealColibri ofrece software de automatización del trading y no presta asesoramiento de inversión: usted toma cada decisión de trading y es responsable de su resultado. Opere únicamente con dinero que pueda permitirse perder.',
    },
    ru: {
        earnHeading: 'Заработок',
        earnAutotrading: 'Автотрейдинг',
        earnToken: 'Токен RCC',
        earnReferral: 'Рефералы',
        earnStaking: 'Стейкинг',
        earnPartner: 'Партнёр',
        signOut: 'Выйти',
        menu: 'Меню',
        autotrading: 'Биржи',
        globalMarkets: 'Глобальные рынки',
        cryptoMarkets: 'Крипторынки',
        premium: 'Премиум',
        guides: 'Руководства',
        whitepaper: 'White Paper',
        terms: 'Условия использования RealColibri',
        home: 'Главная',
        sitemapPlatform: 'Платформа',
        sitemapMarkets: 'Рынки',
        sitemapTrading: 'Торговля',
        sitemapGuides: 'Руководства',
        sitemapLegal: 'Правовое',
        disclaimerTitle: 'Предупреждение о рисках',
        disclaimer:
            'Торговля фьючерсами, опционами и криптовалютными деривативами связана с высоким риском и подходит не каждому инвестору. Вы можете потерять часть вложенных средств или всю сумму. Прошлые результаты не гарантируют будущих. RealColibri предоставляет программное обеспечение для автоматизации торговли и не даёт инвестиционных рекомендаций: решения о сделках вы принимаете самостоятельно и сами несёте ответственность за их результат. Торгуйте только теми средствами, потерю которых можете себе позволить.',
    },
    hy: {
        earnHeading: 'Վաստակ',
        earnAutotrading: 'Ավտոառևտուր',
        earnToken: 'RCC թոքեն',
        earnReferral: 'Հղումներ',
        earnStaking: 'Սթեյքինգ',
        earnPartner: 'Գործընկեր',
        signOut: 'Դուրս գալ',
        menu: 'Մենյու',
        autotrading: 'Բորսաներ',
        globalMarkets: 'Համաշխարհային շուկաներ',
        cryptoMarkets: 'Կրիպտո շուկաներ',
        premium: 'Պրեմիում',
        guides: 'Ուղեցույցներ',
        whitepaper: 'White Paper',
        terms: 'Ընդհանուր դրույթներ և պայմաններ',
        home: 'Գլխավոր',
        sitemapPlatform: 'Հարթակ',
        sitemapMarkets: 'Շուկաներ',
        sitemapTrading: 'Առևտուր',
        sitemapGuides: 'Ուղեցույցներ',
        sitemapLegal: 'Իրավական',
        disclaimerTitle: 'Ռիսկերի մասին նախազգուշացում',
        disclaimer:
            'Ֆյուչերսների և օպցիոնների առևտրի ռիսկը կարող է զգալի լինել: Յուրաքանչյուր ներդրող պետք է հաշվի առնի, արդյոք սա համապատասխան ներդրում է: Անցյալի ցուցանիշները չեն արտացոլում ապագայի արդյունքները: Առևտուր սկսելուց առաջ անհրաժեշտ է գիտակցել, որ հնարավոր շահույթի հետ մեկտեղ կարող են լինել նաև մեծ կորուստներ: Ֆյուչերսների ներդրումը ներառում է ռիսկեր և հարմար չէ բոլորի համար: Այս տեղեկատվության հիման վրա գործող անձինք պատասխանատու են իրենց սեփական գործողությունների համար:',
    },
    fr: {
        earnHeading: 'Gagner',
        earnAutotrading: 'Autotrading',
        earnToken: 'Jeton RCC',
        earnReferral: 'Parrainage',
        earnStaking: 'Staking',
        earnPartner: 'Partenaire',
        signOut: 'Se déconnecter',
        menu: 'Menu',
        autotrading: 'Bourses',
        globalMarkets: 'Marchés mondiaux',
        cryptoMarkets: 'Marchés cryptographiques',
        premium: 'Premium',
        guides: 'Guides',
        whitepaper: 'Livre blanc',
        terms: 'Conditions générales',
        home: 'Accueil',
        sitemapPlatform: 'Plateforme',
        sitemapMarkets: 'Marchés',
        sitemapTrading: 'Trading',
        sitemapGuides: 'Guides',
        sitemapLegal: 'Légal',
        disclaimerTitle: 'Avertissement sur les risques',
        disclaimer:
            'Le trading de contrats à terme, d’options et de produits dérivés sur cryptomonnaies comporte un niveau de risque élevé et ne convient pas à tous les investisseurs. Vous pouvez perdre une partie ou la totalité des sommes investies. Les performances passées ne préjugent pas des résultats futurs. RealColibri fournit un logiciel d’automatisation du trading et ne délivre aucun conseil en investissement : vous prenez vous-même chaque décision de trading et en assumez les conséquences. N’investissez que l’argent que vous pouvez vous permettre de perdre.',
    },
    de: {
        earnHeading: 'Verdienen',
        earnAutotrading: 'Autotrading',
        earnToken: 'RCC-Token',
        earnReferral: 'Empfehlung',
        earnStaking: 'Staking',
        earnPartner: 'Partner',
        signOut: 'Abmelden',
        menu: 'Menü',
        autotrading: 'Börsen',
        globalMarkets: 'Globale Märkte',
        cryptoMarkets: 'Kryptomärkte',
        premium: 'Premium',
        guides: 'Anleitungen',
        whitepaper: 'Whitepaper',
        terms: 'Allgemeine Geschäftsbedingungen',
        home: 'Startseite',
        sitemapPlatform: 'Plattform',
        sitemapMarkets: 'Märkte',
        sitemapTrading: 'Trading',
        sitemapGuides: 'Anleitungen',
        sitemapLegal: 'Rechtliches',
        disclaimerTitle: 'Risikohinweis',
        disclaimer:
            'Der Handel mit Futures, Optionen und Krypto-Derivaten ist mit einem hohen Risiko verbunden und nicht für jeden Anleger geeignet. Sie können Ihr eingesetztes Kapital ganz oder teilweise verlieren. Die Wertentwicklung in der Vergangenheit ist keine Garantie für künftige Ergebnisse. RealColibri stellt Software zur Handelsautomatisierung bereit und erbringt keine Anlageberatung: Jede Handelsentscheidung treffen Sie selbst und tragen die Verantwortung für deren Ergebnis. Handeln Sie nur mit Geld, dessen Verlust Sie sich leisten können.',
    },
    it: {
        earnHeading: 'Guadagna',
        earnAutotrading: 'Autotrading',
        earnToken: 'Token RCC',
        earnReferral: 'Referral',
        earnStaking: 'Staking',
        earnPartner: 'Partner',
        signOut: 'Disconnettersi',
        menu: 'Menu',
        autotrading: 'Exchange',
        globalMarkets: 'Mercati Globali',
        cryptoMarkets: 'Mercati Crypto',
        premium: 'Premium',
        guides: 'Guide',
        whitepaper: 'Whitepaper',
        terms: 'Termini e Condizioni',
        home: 'Home',
        sitemapPlatform: 'Piattaforma',
        sitemapMarkets: 'Mercati',
        sitemapTrading: 'Trading',
        sitemapGuides: 'Guide',
        sitemapLegal: 'Legale',
        disclaimerTitle: 'Avvertenza sui rischi',
        disclaimer:
            'Il trading di futures, opzioni e derivati su criptovalute comporta un livello di rischio elevato e non è adatto a tutti gli investitori. Puoi perdere in parte o del tutto il denaro investito. I risultati passati non garantiscono quelli futuri. RealColibri fornisce un software di automazione del trading e non offre consulenza in materia di investimenti: ogni decisione di trading spetta a te e sei responsabile del suo esito. Opera soltanto con denaro che puoi permetterti di perdere.',
    },
}

export type Language = 'en' | 'es' | 'ru' | 'hy' | 'fr' | 'de'

export default translations
